/* istanbul ignore file -- MSP/LIS quiz is no longer in production */
import React, { useEffect, useState } from 'react';
import { Text } from '@uhg-abyss/web/ui/Text';

import { Button } from '@uhg-abyss/web/ui/Button';
import { Heading } from '@uhg-abyss/web/ui/Heading';
import { DropdownMenu } from '@uhg-abyss/web/ui/DropdownMenu';
import { ProgressBar } from '@uhg-abyss/web/ui/ProgressBar';
import { RadioGroup } from '@uhg-abyss/web/ui/RadioGroup';
import { FormProvider } from '@uhg-abyss/web/ui/FormProvider';
import { useForm } from '@uhg-abyss/web/hooks/useForm';
import { API } from '@src/api';

import { memberInContextAtom } from '@src/global-state';
import { useAtom } from 'jotai';

import { useRouter } from '@uhg-abyss/web/hooks/useRouter';

import { event } from '@uhg-abyss/web/tools/event';

// eslint-disable-next-line react/prop-types
function ShowHeading({ potentiallyEligible, callForMoreInfo, getAllBenfits }) {
  return (
    <React.Fragment>
      {potentiallyEligible ? (
        <div>
          <Heading level={3}>Potentially eligible</Heading>
          <br />
        </div>
      ) : null}

      {callForMoreInfo ? (
        <div>
          <Heading level={3}>Not clear if eligible</Heading>
          <br />
        </div>
      ) : null}

      {getAllBenfits ? (
        <div>
          <Heading level={3}>MSP/LIS pre-qualification</Heading>
          <br />
        </div>
      ) : null}
    </React.Fragment>
  );
}

export type MspLisQuizProps = {
  onExitEarly: () => void;
  onQuizComplete: () => void;
  onQuizReset: () => void;
};

/**
 * MSP/LIS is a quiz that helps users determine if they are eligible
 * for financial help with their Medicare costs.
 */
export const MspLisQuiz = ({
  onExitEarly,
  onQuizComplete,
  onQuizReset,
}: MspLisQuizProps) => {
  const [fisrtQuestion, setFirstQuestion] = useState(false);
  const [secondQuestion, setSecondQuestion] = useState(false);
  const [thirdQuestion, setThirdQuestion] = useState(false);
  const [potentiallyEligible, setPotentiallyEligible] = useState(false);
  const [landing, setLanding] = useState(true);
  const [marriedQuestion, setMarriedQuestion] = useState(false);
  const [dropDownLabel, setDropDownLabel] = useState('Select your state');
  const [selectedState, setSelectedState] = useState('');
  const [selectedMarriageStatus, setSelectedMarriageStatus] = useState('');
  const [salary, setSalary] = useState('<<$xxxx>>');
  const married = 'married';
  const [marriedQuestionBtn, setMarriedQuestionBtn] = useState(true);
  const [stateBTN, setStateBTN] = useState(true);
  const [incomeContinueBTN, setIncomeContinueBTN] = useState(true);
  const [callForMoreInfo, setCallForMoreInfo] = useState(false);
  const [getAllBenfits, setGetAllBenfits] = useState(true);
  const [currentNumberOfQuestion, setCurrentNumberOfQuestion] = useState(1);
  const [showProgressBar, setShowProgressBar] = useState(false);
  const [progress, setProgress] = useState(33);
  const [memberInContext] = useAtom(memberInContextAtom);
  let dropDownValue = '';
  let questionsResponse: { questionValue: string; optionSelected: string }[] = [];
  let memberInfo = {
    id: '',
    nameFirst: '',
    nameLast: '',
    zipcode: '',
  };
  // let currentNumberOfQuestion=1;
  useEffect(() => {
    event('PAGE_LOAD');
  }, []);

  const phoneNumber = '844-965-0017';

  type DropdownItem = {
    title: string;
    onClick?: () => void;
    disabled?: boolean;
    isSeparated?: boolean;
    subMenu?: DropdownItem[];
  };

  function MenuList(
    menuItems,
    updateDropDownLabel: (label: string, acronym: string) => void
  ): DropdownItem[] {
    const result: DropdownItem[] = [];
    for (let i = 0; i < menuItems.length; i++) {
      result.push({
        title: menuItems[i].title,
        onClick: () => {
          updateDropDownLabel(
            `${menuItems[i].title}`,
            `${menuItems[i].acronym}`
          );
        },
        disabled: false,
      });
    }
    return result;
  }

  const getStarted = () => {
    setFirstQuestion(true);
    setLanding(false);
    setShowProgressBar(true);
    event.setData({
      name: 'benefits you deserve quiz',
    });
    event('FORM_START_LOAD');
  };
  const form = useForm({
    defaultValues: {},
  });

  const dropDownOnclick = () => {
  };

  function updateDropDownLabel(label: string, acronym: string) {
    setDropDownLabel(label);
    dropDownValue = label;
    form.setValue('state', label);
    setSelectedState(acronym);
  }

  const menuItems = [
    {
      title: 'Alabama',
      acronym: 'AL',
      onClick: dropDownOnclick,
      disabled: 'false',
    },
    {
      title: 'Alaska',
      acronym: 'AK',
      onClick: dropDownOnclick,
      disabled: 'false',
    },
    {
      title: 'Arizona',
      acronym: 'AZ',
      onClick: dropDownOnclick,
    },
    {
      title: 'Arkansas',
      acronym: 'AR',
      onClick: dropDownOnclick,
    },
    {
      title: 'California',
      acronym: 'CA',
      onClick: dropDownOnclick,
    },
    {
      title: 'Colorado',
      acronym: 'CO',
      onClick: dropDownOnclick,
    },
    {
      title: 'Connecticut',
      acronym: 'CT',
      onClick: dropDownOnclick,
    },
    {
      title: 'Washington D.C.',
      acronym: 'DC',
      onClick: dropDownOnclick,
    },
    {
      title: 'Delaware',
      acronym: 'DE',
      onClick: dropDownOnclick,
    },
    {
      title: 'Florida',
      acronym: 'FL',
      onClick: dropDownOnclick,
    },
    {
      title: 'Georgia',
      acronym: 'GA',
      onClick: dropDownOnclick,
    },
    {
      title: 'Hawaii',
      acronym: 'HI',
      onClick: dropDownOnclick,
    },
    {
      title: 'Idaho',
      acronym: 'ID',
      onClick: dropDownOnclick,
    },
    {
      title: 'Illinois',
      acronym: 'IL',
      onClick: dropDownOnclick,
    },
    {
      title: 'Indiana',
      acronym: 'IN',
      onClick: dropDownOnclick,
    },
    {
      title: 'Iowa',
      acronym: 'IA',
      onClick: dropDownOnclick,
    },
    {
      title: 'Kansas',
      acronym: 'KS',
      onClick: dropDownOnclick,
    },
    {
      title: 'Kentucky',
      acronym: 'KY',
      onClick: dropDownOnclick,
    },
    {
      title: 'Louisiana',
      acronym: 'LA',
      onClick: dropDownOnclick,
    },
    {
      title: 'Maine',
      acronym: 'ME',
      onClick: dropDownOnclick,
    },
    {
      title: 'Maryland',
      acronym: 'MD',
      onClick: dropDownOnclick,
    },
    {
      title: 'Massachusetts',
      acronym: 'MA',
      onClick: dropDownOnclick,
    },
    {
      title: 'Michigan',
      acronym: 'MI',
      onClick: dropDownOnclick,
    },
    {
      title: 'Minnesota',
      acronym: 'MN',
      onClick: dropDownOnclick,
    },
    {
      title: 'Mississippi',
      acronym: 'MS',
      onClick: dropDownOnclick,
    },
    {
      title: 'Missouri',
      acronym: 'MO',
      onClick: dropDownOnclick,
    },
    {
      title: 'Montana',
      acronym: 'MT',
      onClick: dropDownOnclick,
    },
    {
      title: 'Nebraska',
      acronym: 'NE',
      onClick: dropDownOnclick,
    },
    {
      title: 'Nevada',
      acronym: 'NV',
      onClick: dropDownOnclick,
    },
    {
      title: 'New Hampshire',
      acronym: 'NH',
      onClick: dropDownOnclick,
    },
    {
      title: 'New Jersey',
      acronym: 'NJ',
      onClick: dropDownOnclick,
    },
    {
      title: 'New Mexico',
      acronym: 'NM',
      onClick: dropDownOnclick,
    },
    {
      title: 'New York',
      acronym: 'NY',
      onClick: dropDownOnclick,
    },
    {
      title: 'North Carolina',
      acronym: 'NC',
      onClick: dropDownOnclick,
    },
    {
      title: 'North Dakota',
      acronym: 'ND',
      onClick: dropDownOnclick,
    },
    {
      title: 'Ohio',
      acronym: 'OH',
      onClick: dropDownOnclick,
    },
    {
      title: 'Oklahoma',
      acronym: 'OK',
      onClick: dropDownOnclick,
    },
    {
      title: 'Oregon',
      acronym: 'OR',
      onClick: dropDownOnclick,
    },
    {
      title: 'Pennsylvania',
      acronym: 'PA',
      onClick: dropDownOnclick,
    },
    {
      title: 'Rhode Island',
      acronym: 'RI',
      onClick: dropDownOnclick,
    },
    {
      title: 'South Carolina',
      acronym: 'SC',
      onClick: dropDownOnclick,
    },
    {
      title: 'South Dakota',
      acronym: 'SD',
      onClick: dropDownOnclick,
    },
    {
      title: 'Tennessee',
      acronym: 'TN',
      onClick: dropDownOnclick,
    },
    {
      title: 'Texas',
      acronym: 'TX',
      onClick: dropDownOnclick,
    },
    {
      title: 'Utah',
      acronym: 'UT',
      onClick: dropDownOnclick,
    },
    {
      title: 'Vermont',
      acronym: 'VT',
      onClick: dropDownOnclick,
    },
    {
      title: 'Virginia',
      acronym: 'VA',
      onClick: dropDownOnclick,
    },
    {
      title: 'Washington',
      acronym: 'WA',
      onClick: dropDownOnclick,
    },
    {
      title: 'West Virginia',
      acronym: 'WV',
      onClick: dropDownOnclick,
    },
    {
      title: 'Wisconsin',
      acronym: 'WI',
      onClick: dropDownOnclick,
    },
    {
      title: 'Wyoming',
      acronym: 'WY',
      onClick: dropDownOnclick,
    },
  ];

  const firstQuestionContinue = () => {
    setFirstQuestion(false);
    setSecondQuestion(true);
    setLanding(false);
    setCurrentNumberOfQuestion(2);
    setProgress(66);
  };

  const secondQuestionContinue = async () => {
    const resp = await API.getEligibleIncome(
      selectedState,
      selectedMarriageStatus
    );
    setSalary(resp?.data?.income ?? '');
    setSecondQuestion(false);
    setThirdQuestion(true);
    setCurrentNumberOfQuestion(3);
    setProgress(100);
  };

  const redoQuiz = () => {
    setPotentiallyEligible(false);
    setFirstQuestion(false);
    setSecondQuestion(false);
    setLanding(true);
    setIncomeContinueBTN(true);
    setMarriedQuestionBtn(true);
    setGetAllBenfits(true);
    setPotentiallyEligible(false);
    setCallForMoreInfo(false);
    setStateBTN(true);
    setStateBTN(true);
    questionsResponse = [];
    memberInfo = {
      id: '',
      nameFirst: '',
      nameLast: '',
      zipcode: '',
    };
    form.setValue('state', '');
    setDropDownLabel('Select your state');
    setCurrentNumberOfQuestion(1);
    setProgress(33);

    form.reset();
    onQuizReset();
  };

  const firstBack = () => {
    setFirstQuestion(false);
    setLanding(true);
    setShowProgressBar(false);
  };

  const secondBack = () => {
    setSecondQuestion(false);
    setFirstQuestion(true);
    setCurrentNumberOfQuestion(1);
    setProgress(33);
  };

  const thirdBack = () => {
    setThirdQuestion(false);
    setSecondQuestion(true);
    setCurrentNumberOfQuestion(2);
    setProgress(66);
  };

  let data: any;

  const onSubmit = (data) => {
  };

  const thirdQuestionContinue = () => {
    event.setData({
      name: 'benefits you deserve quiz?',
    });
    event('FORM_END_LOAD');
    setThirdQuestion(false);
    setShowProgressBar(false);
    questionsResponse = [
      { questionValue: 'Where do you live?', optionSelected: data.state },
      {
        questionValue: 'What is your marital status?',
        optionSelected: data.married,
      },
      {
        questionValue: `Is your income below ${salary}?`,
        optionSelected: data.income,
      },
    ];

    if (data.married === married) {
      questionsResponse = [
        ...questionsResponse,
        {
          questionValue:
            'Do you or your spouse earn income from a job or self-employment?',
          optionSelected: data.spouse,
        },
      ];
    }

    fetchMemberDetails();
    saveQuizResponse();

    if (data.income === 'Yes') {
      setCallForMoreInfo(false);
      setPotentiallyEligible(true);
    }
    if (data.income === 'No') {
      setPotentiallyEligible(false);
      setCallForMoreInfo(true);
    }
    setGetAllBenfits(false);
    onQuizComplete();
  };

  const saveQuizResponse = async () => {
    await API.getsaveQuizResponse(
       memberInfo.id,
       memberInfo.zipcode,
       questionsResponse as unknown as string[],
       memberInfo.nameFirst,
       memberInfo.nameLast,
    );
  };

  const fetchMemberDetails = () => {
    memberInfo = {
      nameFirst: memberInContext?.first_name ?? '',
      nameLast: memberInContext?.last_name ?? '',
      id: memberInContext?.member_id ?? '',
      zipcode: memberInContext?.zipCode ?? '',
    };
  };

  const SalaryDisplay = ({ salary, size, color }) => {
    const formatSalary = (salary) => {
      const roundedSalary = Math.round(salary);
      return roundedSalary.toLocaleString();
    };
    const formattedSalary = formatSalary(salary);
    return (
      <div style={{ fontSize: size, color: color }}>${formattedSalary}</div>
    );
  };

  useEffect(() => {
    data = form.getValues();
    if (data.married === married) {
      setSelectedMarriageStatus('couple');
      setMarriedQuestion(true);
    } else {
      setSelectedMarriageStatus('individual');
      setMarriedQuestion(false);
    }

    if (data.state) setStateBTN(false);

    if (data.married === married && marriedQuestionBtn === false) {
      setMarriedQuestionBtn(true);
    }

    if (
      data.married === married &&
      (data.spouse === 'Yes' || data.spouse === 'No')
    ) {
      setMarriedQuestionBtn(false);
    }

    if (data.married === 'singleDivorcedWidowedSeparated') {
      setMarriedQuestionBtn(false);
    }

    if (data.income === 'Yes' || data.income === 'No') {
      setIncomeContinueBTN(false);
    }
  }, [form]);

  return (
    <React.Fragment>
      <div
        style={{
          width: '100%',
          height: '100%',
          position: 'relative',
          top: '0px',
          right: '0px',
          bottom: '0px',
          left: '0px',
          backgroundColor: 'white',
        }}
      >
        <FormProvider state={form} onSubmit={onSubmit}>
          <div
            style={{
              display: 'flex',
              justifyContent: 'flex-end',
              paddingLeft: '40px',
              paddingRight: '40px',
              paddingTop: '40px',
            }}
          >
            <div>
              <Button variant="text" onClick={onExitEarly}>
                Close
              </Button>
            </div>
          </div>

          <div
            style={{
              display: 'flex',
              justifyContent: 'center',
              paddingBottom: '20px',
              paddingTop: '20px',
              paddingLeft: '40px',
              paddingRight: '40px',
            }}
          >
            <br />
            <div>
              <ShowHeading
                potentiallyEligible={potentiallyEligible}
                callForMoreInfo={callForMoreInfo}
                getAllBenfits={getAllBenfits}
              />

              {/* ------------------------ Landing --------------------------------- */}

              {landing ? (
                <div>
                  <div>
                    You may be eligible for help with your Medicare Part A&B or{' '}
                    <br />
                    Medicare Part D costs.
                  </div>
                  <div style={{ marginTop: '12px' }}>
                    Answer a few questions to see if you qualify.
                  </div>
                  <br />
                  <br />
                  <br />
                  <Button
                    id="get_started"
                    style={{ width: '100%' }}
                    onClick={getStarted}
                  >
                    Get started
                  </Button>
                </div>
              ) : null}

              {showProgressBar ? (
                <div>
                  <label>{currentNumberOfQuestion} of 3 Questions</label>
                  <div
                    style={{
                      width: '400px',
                      border: '2px solid #929496',
                      borderRadius: '3px',
                    }}
                  >
                    <ProgressBar
                      label={`${currentNumberOfQuestion} of 3 Questions`}
                      hideLabel
                      percentage={progress}
                    />
                  </div>
                </div>
              ) : null}
              {/*  ------------------------- First Question -------------------------- */}

              {fisrtQuestion ? (
                <div>
                  <div style={{ marginTop: '12px', marginBottom: '4px' }}>
                    Where do you live?
                  </div>
                  <div style={{ marginBottom: '8px' }}>
                    Select your state
                  </div>

                  <DropdownMenu
                    outline
                    label={dropDownLabel}
                    onOpenChange={dropDownOnclick}
                    menuItems={MenuList(menuItems, updateDropDownLabel)}
                    // menuItems = {menuItems}

                    css={{
                      'abyss-dropdown-menu-trigger': {
                        width: '400px',
                        zIndex: '999',
                      },
                      'abyss-insert-element-root': {
                        display: 'flex',
                        justifyContent: 'space-between',
                        zIndex: '999',
                      },
                      'abyss-dropdown-menu-item': {
                        width: '375px',
                        border: '10px',
                        zIndex: '999',
                      },
                      'abyss-dropdown-menu-item-icon-container': {
                        backgroundColor: 'white',
                        width: '380px',
                      },
                      'abyss-dropdown-menu-content': {
                        backgroundColor: 'white',
                        zIndex: '999',
                        width: '420px',
                        overflowY: 'scroll',
                        height: '300px',
                        overflowX: 'hidden',
                      },
                      'abyss-dropdown-menu-item-separator': {
                        backgroundColor: 'black',
                        width: '400px',
                        zIndex: '999',
                      },
                    }}
                  />

                  <br />
                  <br />
                  <br />
                  <br />
                  <div style={{ display: 'flex', justifyContent: 'center' }}>
                    <Button
                      variant="outline"
                      style={{ width: '48%' }}
                      onClick={firstBack}
                    >
                      Back
                    </Button>
                    <Button
                      style={{ width: '48%', marginLeft: '15px' }}
                      onClick={firstQuestionContinue}
                      isDisabled={stateBTN}
                    >
                      Continue
                    </Button>
                  </div>
                </div>
              ) : null}

              {/* -------------------------- Second Question -------------------------- */}

              {secondQuestion ? (
                <div>
                  <label>
                    <br />
                    What is your marital status?
                  </label>
                  <br />
                  <div>
                    <RadioGroup
                      label="Marital status"
                      hideLabel
                      model="married"
                      css={{
                        'abyss-radio-group-container': { paddingLeft: '20px' },
                      }}
                    >
                      <RadioGroup.Radio
                        label="Single / Divorced / Widowed / Separated "
                        value="singleDivorcedWidowedSeparated"
                      />
                      <br />
                      <RadioGroup.Radio label="Married" value="married" />
                    </RadioGroup>
                  </div>

                  {marriedQuestion ? (
                    <div>
                      <label>
                        <br />
                        Do you or your spouse earn income from a job or
                        <br /> self-employment?
                      </label>
                      <br />
                      <div>
                        <RadioGroup
                          label="Spouse employment income"
                          hideLabel
                          model="spouse"
                          css={{
                            'abyss-radio-group-container': {
                              paddingLeft: '20px',
                            },
                          }}
                        >
                          <RadioGroup.Radio label="Yes " value="Yes" />
                          <br />
                          <RadioGroup.Radio label="No" value="No" />
                        </RadioGroup>
                      </div>
                    </div>
                  ) : null}
                  <br />
                  <br />
                  <div style={{ display: 'flex', justifyContent: 'center' }}>
                    <Button
                      variant="outline"
                      style={{ width: '48%' }}
                      onClick={secondBack}
                    >
                      Back
                    </Button>
                    <Button
                      id="second_continue"
                      style={{ width: '48%', marginLeft: '15px' }}
                      onClick={secondQuestionContinue}
                      isDisabled={marriedQuestionBtn}
                    >
                      Continue
                    </Button>
                  </div>
                </div>
              ) : null}

              {/* -------------------------- Third Question -------------------------- */}

              {thirdQuestion && (
                <div>
                  <label>
                    <br />
                    Is your income below
                    <br />
                    <div style={{ display: 'flex' }}>
                      <SalaryDisplay salary={salary}
                        size="20px"
                        color="#196ecf"
                      />
                      ?
                    </div>
                  </label>
                  <br />
                  <div>
                    <RadioGroup
                      label="Income below threshold"
                      hideLabel
                      model="income"
                      css={{
                        'abyss-radio-group-container': { paddingLeft: '20px' },
                      }}
                    >
                      <RadioGroup.Radio label="Yes" value="Yes" />
                      <br />
                      <RadioGroup.Radio label="No" value="No" />
                    </RadioGroup>
                  </div>

                  <br />
                  <br />
                  <div style={{ display: 'flex', justifyContent: 'center' }}>
                    <Button
                      variant="outline"
                      style={{ width: '48%' }}
                      onClick={thirdBack}
                    >
                      Back
                    </Button>
                    <Button
                      style={{ width: '48%', marginLeft: '15px' }}
                      onClick={thirdQuestionContinue}
                      isDisabled={incomeContinueBTN}
                    >
                      Continue
                    </Button>
                  </div>
                </div>
              )}

              {/* -------------------------- Potentially Eligible -------------------------- */}

              {potentiallyEligible && (
                <div>
                  <div style={{ fontWeight: 'bold', marginBottom: '8px' }}>
                    Result
                  </div>
                  <div>
                    Based on your responses you may be eligible for help
                    <br />
                    with your Medicare costs. I can transfer you now or <br />
                    you can call&nbsp;
                    <Text fontWeight="regular" color="#196ecf" fontSize="md">
                      {phoneNumber}
                    </Text>{' '}
                    to explore your next steps.
                  </div>
                  <br />

                  <div style={{ fontWeight: 'bold' }}>
                    Call center hours
                  </div>
                  <div>
                    Monday-Saturday 8 a.m.-8 p.m. local time
                  </div>

                  <br />
                  <br />
                  <Button
                    variant="outline"
                    style={{ width: '100%' }}
                    onClick={redoQuiz}
                  >
                    Redo cost savings quiz
                  </Button>
                </div>
              )}

              {callForMoreInfo && (
                <div>
                  <div style={{ fontWeight: 'bold', marginBottom: '8px' }}>
                    Result
                  </div>
                  <div>
                    Based on your responses to this general screening, it is not
                    <br /> clear if you qualify. If you would like to explore
                    further,
                    <br /> I can transfer you now or you can call &nbsp;
                    <Text fontWeight="regular" color="#196ecf" fontSize="md">
                      {phoneNumber}
                    </Text>
                  </div>
                  <br />

                  <div style={{ fontWeight: 'bold' }}>
                    Call center hours
                  </div>
                  <div>
                    Monday-Saturday 8 a.m.-8 p.m. local time
                  </div>

                  <br />
                  <br />
                  <Button
                    variant="outline"
                    style={{ width: '100%' }}
                    onClick={redoQuiz}
                  >
                    Redo cost savings quiz
                  </Button>
                </div>
              )}
            </div>
          </div>
        </FormProvider>
      </div>
    </React.Fragment>
  );
};
